import { Skeleton } from '@/Domain/components/Shared/Skeleton/Skeleton';

export const SubscriptionSkeleton = () => (
  <div className="flex flex-col gap-12 w-full max-w-7xl mx-auto">
    <section>
      <header className="text-lg font-semibold text-foreground mb-4">
        <Skeleton className="h-6 w-24 " />
      </header>
      <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4">
        <Skeleton className="h-52 w-full rounded-xl" />
        <Skeleton className="h-52 w-full rounded-xl" />
      </div>
    </section>

    <section>
      <header className="flex items-center justify-between text-lg font-semibold text-foreground mb-4">
        <Skeleton className="h-6 w-16 " />
        <div className="flex items-center gap-4">
          <Skeleton className="h-5 w-52 " />
        </div>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Skeleton className="h-96 w-full rounded-xl" />
        <Skeleton className="h-96 w-full rounded-xl" />
        <Skeleton className="h-96 w-full rounded-xl" />
      </div>
    </section>
  </div>
);
